import {
  Button,
  Flex,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Text,
} from '@ritualco/jutsu'
import 'react-multi-email/style.css'
import * as Yup from 'yup'
import { Form, Formik, FormikProps } from 'formik'
import { FormikMultiEmailInput } from 'components/Formik'
import { HeraModal } from 'components/HeraModal'
import { useContent } from 'lib/content/react'
import { PeopleCreateFormType, PeopleCreateModalProps } from './types'

const initialValues: PeopleCreateFormType = {
  emails: [],
}

export const PeopleCreateModal = ({
  onSubmit,
  onClose,
  ...modalProps
}: PeopleCreateModalProps) => {
  const { formatMessage } = useContent()
  const FormValueTypeSchema = Yup.object().shape({
    emails: Yup.array(Yup.string().email().required()).min(
      1,
      formatMessage({ id: 'pmportal.settings.team.errors.emails' })
    ),
  })

  return (
    <HeraModal size="2xl" onClose={onClose} {...modalProps}>
      <Formik
        initialValues={initialValues}
        validationSchema={FormValueTypeSchema}
        onSubmit={async (values, actions) => {
          await onSubmit(values.emails)
          actions.setSubmitting(false)
          onClose()
        }}
      >
        {(props: FormikProps<PeopleCreateFormType>) => (
          <>
            <ModalHeader>
              {formatMessage({ id: 'pmportal.companies.invitePeople.header' })}
            </ModalHeader>
            <ModalBody>
              <Form id="peopleCreate">
                <Flex direction="column">
                  <Text
                    fontSize="small"
                    color="grayscale.secondary"
                    mb={9}
                    mt={-1}
                  >
                    {formatMessage({
                      id: 'pmportal.companies.invitePeople.desc',
                    })}
                  </Text>
                  <FormikMultiEmailInput
                    label={formatMessage({
                      id: 'pmportal.companies.emailHeading',
                    })}
                    placeholder={formatMessage({
                      id: 'pmportal.companies.inviteEmployees.placeholder',
                    })}
                    name="emails"
                    isRequired
                    {...props}
                  />
                  <Text
                    fontWeight={'thin'}
                    fontSize="xs"
                    color="grayscale.secondary"
                  >
                    {formatMessage({
                      id: 'pmportal.companies.inviteEmployees.tip',
                    })}
                  </Text>
                </Flex>
              </Form>
            </ModalBody>
            <ModalFooter>
              <Button colorScheme="transparent" mr={2} onClick={onClose}>
                {formatMessage({ id: 'pmportal.global.actionCancel' })}
              </Button>
              <Button
                type="submit"
                form="peopleCreate"
                isLoading={props.isSubmitting}
              >
                {formatMessage({ id: 'pmportal.companies.sendInvites' })}
              </Button>
            </ModalFooter>
          </>
        )}
      </Formik>
    </HeraModal>
  )
}
